import React from 'react';
import { ArrayHelpers, Paging, SystemText } from '@salesperformanceint/e4shared';
import { useDispatch } from 'react-redux';
import { setPrismMenu } from 'actions/ui';
import Bullet from 'components/prism/bullet';
import NoResults from 'components/prism/noResults';
import Subheader from 'components/prism/subheader';
import { e4Format } from 'helpers/dates';
import isToday from 'date-fns/isToday';

export const ReviewsList = ({ data, setDetail }) => {
    const dispatch = useDispatch();
    const [scheduled, setScheduled] = React.useState([]);
    const [completed, setCompleted] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const pageSize = 10;

    const text = {
        title: {
            scheduled: SystemText('Reviews/Title/Scheduled'),
            completed: SystemText('Reviews/Title/Completed'),
        },
        table: {
            scheduled: SystemText('Reviews/Table/Scheduled'),
            capabilities: SystemText('Reviews/Table/Capabilities'),
            assignedBy: SystemText('Reviews/Table/AssignedBy'),
            due: SystemText('Reviews/Table/DueDate'),
            status: SystemText('Reviews/Table/Status'),
            completed: SystemText('Reviews/Table/Completed'),
        },
        buttons: {
            start: SystemText('Reviews/Buttons/Start'),
            resume: SystemText('Reviews/Buttons/Resume'),
            summary: SystemText('Reviews/Buttons/Summary'),
        },
        noResults: {
            title: SystemText('Reviews/NoResults/Title'),
            summary: SystemText('Reviews/NoResults/Summary'),
        },
    };

    React.useEffect(() => {
        dispatch(setPrismMenu('reviews'));
    }, []);

    React.useEffect(() => {
        setPage(1);
        setScheduled(data.filter(x => !x.submission));
        setCompleted(data.filter(x => x.submission));
    }, [data]);

    return (
        <>
            <Subheader title={text.title.scheduled} count={scheduled.length} />
            {scheduled.length > 0 ? (
                <>
                    <table className="prism-table mb10">
                        <thead>
                            <tr>
                                <th>{text.table.scheduled}</th>
                                <th>{text.table.capabilities}</th>
                                <th>{text.table.assignedBy}</th>
                                <th>{text.table.due}</th>
                                <th>{text.table.status}</th>
                                {scheduled.some(s => ['U', 'UM'].some(x => x === s.participants)) && <th></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {scheduled.map(d => {
                                const status =
                                    d.scheduled < new Date()
                                        ? 'overdue'
                                        : isToday(d.scheduled)
                                          ? 'due_today'
                                          : 'outstanding';

                                return (
                                    <tr key={`review-${d.id}`}>
                                        <td>{e4Format(d.launch)}</td>
                                        <td>{d.competency_Ids?.length || d.competency_Count}</td>
                                        <td>{d.owner_Full_Name || '-'}</td>
                                        <td>
                                            <Bullet isDate value={d.scheduled} />
                                        </td>
                                        <td>
                                            <Bullet isStatus value={status} />
                                        </td>
                                        {['U', 'UM'].some(x => x === d.participants) && (
                                            <td>
                                                <button
                                                    className="btn btn-primary btn-cornered"
                                                    onClick={() => setDetail(d)}
                                                >
                                                    {d.user_Predictions ? text.buttons.resume : text.buttons.start}
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            ) : (
                <div className="row">
                    <div className="col-md-12">
                        <NoResults icon="speedometer" title={text.noResults.title} summary={text.noResults.summary} />
                    </div>
                </div>
            )}
            {completed.length > 0 && (
                <div className="mt20">
                    <Subheader title={text.title.completed} count={completed.length} />
                    <table className="prism-table mb10">
                        <thead>
                            <tr>
                                <th>{text.table.scheduled}</th>
                                <th>{text.table.capabilities}</th>
                                <th>{text.table.assignedBy}</th>
                                <th>{text.table.due}</th>
                                <th>{text.table.status}</th>
                                <th>{text.table.completed}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ArrayHelpers.getPage(completed, page, pageSize).map(d => {
                                const status = d.submission > d.scheduled ? 'late' : 'on_time';

                                return (
                                    <tr key={`review-${d.id}`}>
                                        <td>{e4Format(d.launch)}</td>
                                        <td>{d.competency_Ids?.length || d.competency_Count}</td>
                                        <td>{d.owner_Full_Name || '-'}</td>
                                        <td>
                                            <Bullet isDate value={d.scheduled} />
                                        </td>
                                        <td>
                                            <Bullet isStatus value={status} />
                                        </td>
                                        <td>{e4Format(d.submission)}</td>
                                        <td>
                                            <button className="btn btn-primary btn-cornered" onClick={() => setDetail(d)}>
                                                {text.buttons.summary}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {completed.length > pageSize && (
                        <div className="text-center ">
                            <Paging page={page} pageSize={pageSize} recordCount={completed.length} goToPage={setPage} />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default ReviewsList;
